export default () => {
    const extensions = map => {
        const canEditNodeText = map.canEditNodeText.bind(map)
        const startEditNodeText = map.startEditNodeText.bind(map)

        return {
            canEditNodeText(node) {
                if (! this.permission.has('write')) {
                    return false
                }

                const n = this.nodeProxy(node)

                if (! n.canWriteData()) {
                    return false
                }

                return canEditNodeText(node)
            },

            editNodeText(node, text) {
                const n = this.nodeProxy(node)
                const data = n.mapSetTextData(text)
                this.commands.updateNodeData([node], () => data)
            },

            startEditNodeText(node, text) {
                if (! this.permission.has('write')) {
                    return
                }

                const n = this.nodeProxy(node)

                if (! n.canWriteData()) {
                    return
                }

                return startEditNodeText(node, text)
            },
        }
    }

    return {extensions}
}
